// 计费单

import { HttpGetInventoryCodeMapfindByPage, HttpGetInventoryCodeMapDeleteById } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import skuImport from './skuImport'
import compAdd from './add'
export default {
    mixins: [TableList],
    components: {
        skuImport,
        compAdd,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            searsku:'',
            Plugins: { show: true },
        };
    },
    mounted() {
        // this.bus.$on("changereset", value => {
        //     if(value === 'reset'){
        //         this.searsku = ''
        //         this.$set(this.formData.search,'CN_itemsku','')
        //         this.search()
        //     }

        // });
	},
    methods: {
        ajaxRequest: HttpGetInventoryCodeMapfindByPage,
        interceptRequest(params){
            console.log(this.resetdata)
            // params.search.CN_itemsku = this.searsku;
            return params;
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'skuImport':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
                        width: 'middle',
                        showFooter: false,
                        component: "skuImport",
                    }
                    break;
                case 'add':
                    this.operate = {
                        show: true,
                        title: this.$t('global.common.add', { defaultValue: '添加' }),
                        width: 'middle',
                        showFooter: false,
                        component: "compAdd",
                    }
                    break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { ids: params },
                        title: this.$t('global.common.delete', { defaultValue: "删除" }),
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: "删除后不可恢复，是否确认删除？" }),
                        ajaxRequest: HttpGetInventoryCodeMapDeleteById
                    };
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getBillcusorgList', 'getCusproductList', 'getBillcusWareList', 'getWarehouseAllList']),
        ...mapGetters('common', ['getInventoryType', 'getProductType']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.import', { defaultValue: "导入" }),
                    operate: "skuImport",
                    theme: "info",
                },
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add"
                },
                {
                    name: this.$t('global.common.delete', { defaultValue: "删除" }),
                    batch: true,
                    operate: "del"
                },
            ]
        },
        SearchsData(row) {
            return [
                {
                    label: "SKU",
                    key: 'CN_itemsku',
                    show: true,
                    // tag: 'vInput',
                    tag: 'div',
                    removeInput: true,
                    hideSearchTip: true,
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                showread:'showyes',
                                value: this.formData.search.CN_itemsku,
                            },
                            on: {
                                'on-data': (row) => {
                                    // console.log(row,row.erpSku)
                                    this.$set(this.formData.search,'CN_itemsku',row.erpSku)
                                    // this.searsku = row.erpSku;
                                },
                            }
                        })
                    }
                },
                {
                    label: this.$t('fbb.sku.code', { defaultValue: "识别码" }),
                    key: 'CN_depotskualias',
                    show: true,
                    tag: 'vInput',
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: 'SKU',
                    key: 'itemsku',
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.itemsku}</div>
                            </div>
                        )
                    }
                },
                {
                    title: this.$t('global.common.name', { defaultValue: '名称' }),
                    key: 'productName',
                },
                {
                    title: this.$t('fbb.sku.code', { defaultValue: 'SKU识别码' }),
                    key: 'depotskualias',
                },
                {
                    title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
    },
};




